require("./d3");
module.exports = d3;
(function () { delete this.d3; })(); // unset global



//////////////////
// WEBPACK FOOTER
// ./~/rickshaw/~/d3/index-browserify.js
// module id = 1229
// module chunks = 0